import React, { useState } from "react";
import "./navbar.scss";
import Logo from "../../asset/logo.webp";
import { HashLink } from "react-router-hash-link";
import { FaBars } from "react-icons/fa";
import { RiCloseLine } from "react-icons/ri";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="navbar">
      <div className="container-navbar">
        <div className="logo">
          <h2>Mitra Pemasaran BSD City</h2>
          <p>Konsultan Properti Independen - +6281319499502</p>
        </div>
        <div className={isOpen ? "menus active" : "menus"}>
          <ul>
            <li>
              <a href="/tentangkami.html">About</a>
            </li>
            <li>
              <HashLink className="link" smooth to="/#promo">
                Promo
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="/residentials">
                Residentials
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="/commercials">
                Commercials
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="/#lokasi">
                Lokasi
              </HashLink>
            </li>
          </ul>
        </div>
        <div className="icons" onClick={toggleMenu}>
          <FaBars className={isOpen ? "bars active" : "bars"} />
          <RiCloseLine className={isOpen ? "close active" : "close"} />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
